'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    backgroundColor: _colors2.default.background,
    position: 'relative',
    backgroundImage: 'url()'
  },
  status: {
    width: '10px',
    height: '10px',
    border: '1px solid ' + _colors2.default.white,
    backgroundColor: _colors2.default.offline,
    borderRadius: '50%',
    position: 'absolute',
    right: 0,
    top: 0
  }
};
module.exports = exports.default;